import { useMemo } from 'react'
import { checkUniqueFields } from '../utils/common'

export default function useUniquenessCheck({ fieldPrefix, formMethods, data = {}, fields = [] }) {
	const { watch = () => { }, setError = () => { }, formState = {} } = formMethods || {}

	const formValues = watch(fieldPrefix)

	// Stable reference
	const previous = useMemo(() => data || {}, [data])

	const checkUniqueness = async () => {
		let isUnique = true

		try {
			// Skip check if no changes
			const nothingChanged = fields.every((field) => previous[field] === formValues?.[field])

			if (nothingChanged) return true

			// Build payload
			const payload = {}
			fields.forEach((field) => (payload[field] = formValues?.[field]))

			if (data?.id) payload.id = data.id

			// API call
			const response = await checkUniqueFields(payload)

			// Loop through API response
			for (const [field, exists] of Object.entries(response)) {
				if (exists) {
					const errorPath = `${fieldPrefix}.${field}`
					setError(errorPath, {
						type: 'manual',
						message: `${field.replace(/_/g, ' ').toLowerCase()} already exists`,
					})

					isUnique = false
				}
			}

			return isUnique
		} catch (error) {
			console.error('Uniqueness check failed:', error)
			return isUnique
		}
	}

	return { checkUniqueness }
}
